module.exports = __webpack_public_path__ + "static/img/score-popup-bg.d7f105ee.png";